import { agentSearch } from "@/api/search.service";
import { appointmentManagerSearch } from "@/api/agents.service";

export const useAgentSearch = () => {
  const itemTitle = i => [i.name, i.email].filter(Boolean).join(" · ");
  return {
    itemTitle,
    comparisonValue: v => v.id,
    fetchResults: async (search, searchArgs) => {
      let func = v => agentSearch(v, searchArgs.includeAssignable);
      if (searchArgs.appointmentManager) func = appointmentManagerSearch;
      const res = await func(search);

      const items = res.map(a => {
        let assignable = a?.assignable;
        if (assignable) {
          assignable = {
            ...assignable,
            type: assignable?.type?.model || assignable?.type
          };
        }

        return {
          ...a,
          assignable,
          type: a?.type?.model || a?.type
        };
      });

      return items.toSorted((a, b) => itemTitle(a).localeCompare(itemTitle(b)));
    }
  };
};
